var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 294.05 294.05",
    style: {
      enableBackground: "new 0 0 294.05 294.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFC303;}\n\t.st1{fill:#1A1A1A;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 147.02,
    cy: 147.02,
    r: 147.02
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.59,144.46h22.43v92.43c0.01,1.82,1.49,3.3,3.31,3.3h38.06c1.82,0,3.3-1.48,3.31-3.3v-92h25.81 c1.68,0,3.09-1.26,3.28-2.93l3.92-34c0.21-1.81-1.09-3.45-2.9-3.66c-0.13-0.01-0.25-0.02-0.38-0.02h-29.71V82.94 c0-6.43,3.46-9.69,10.29-9.69h19.44c1.82-0.01,3.3-1.49,3.3-3.31V38.71c0-1.82-1.48-3.3-3.3-3.3l0,0h-26.79c-0.19,0-0.61,0-1.23,0 c-4.65,0-20.8,0.92-33.56,12.66c-14.14,12.95-12.18,28.55-11.71,31.25v25H98.59c-1.82,0-3.3,1.48-3.3,3.3l0,0v33.59 C95.32,143.01,96.79,144.46,98.59,144.46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFb);
export default __webpack_public_path__ + "static/media/iconoFB.474e1ddc6a7709a0b554dbb624c9e2a7.svg";
export { ForwardRef as ReactComponent };